import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';


const L2PendingList = ({
        // getListFilterData,
        filterDropdownList = [],
        getCampaignData,
        getCampaignListing = [],
        updateCampaignData,
        updateStatusForCampaign = [],
        match,
        history
    }) => {
    const headers = [
        'Campaign Type',
        'Campaign Subtype',
        'Campaign Start Date',
        'Estimated Revenue',
        'Created By',
        'Created By Email',
        'Created At',
        'Status',
        'Start',
        'Action'
    ];
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isStatusSuccess, setIsStatusSuccess] = useState(false);
    const [isRoleId, setIsRoleId] = useState(null);
    const {baseUrl} = useContext(BaseUrl);
    const [isRejectedModal, setIsRejectedModal] = useState(false);
    const [isApprovedModal, setIsApprovedModal] = useState(false);
    const [isConfirmationModal, handleConfirmationModal] = useState(false);
    const [getCampaignId, setGetCampaignId] = useState(null);

    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(localStorage.getItem('roles'));
            roles && setIsRoleId(roles[0].pivot.role_id);
        })();
    }, []);
    
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getCampaignData(1, filterData, 3)
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'campaign_type',
            'campaign_subtype',
            'start_date',
            'est_revenue',
            'name',
            'email',
            'created_at',
            'status_name',
        ];

        if (getCampaignListing.data) {
            const data = getCampaignListing.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                        {
                            'invoice_start': element.id,
                        },
                        {
                            Action: [
                                {
                                    name: 'View Details', 
                                    link: `campaign-view`
                                }
                        ]
                            
                        }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(getCampaignListing.total / getCampaignListing.per_page));
        }
    }, [getCampaignListing]);


    const applyFilter = async (filterData) => {
        localStorage.setItem("getCampaignListing", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await getCampaignData(1, filterData, 3);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await getCampaignData(val.selected + 1, filter, 3);
        localStorage.setItem('page', val.selected + 1)
        setIsLoading(false);
    };

    const handleApprovedModalHide = () => {
        setIsApprovedModal(false);
      };

    const handleConfirmationModalHide = () => {
        handleConfirmationModal(false);
    };


    const handleInvoiceStart = async (id) => {
        setIsLoading(true); 
        console.log('Invoice started');
        setGetCampaignId(id);
        handleConfirmationModal(true, id); 
        setIsLoading(false); 
    };

    const handleStartCampaign = async(id) => {
        // Payload for updateCampaignData function
        const payload = {
            id: id,
            status: 4
        };
        setIsLoading(true); 
        const res = await updateCampaignData(payload); 
        setIsLoading(false); 
    
        if (res) {
            setIsApprovedModal(true); 
        } else {
            setIsApprovedModal(true); 
        }
    }

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""/>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    return (
        <Layout
            title={localization.l2PendingList}
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                detailList={getCampaignListing && getCampaignListing.data}
                pageCount={pageCount}
                srNo={getCampaignListing?.from}
                onPageChange={onPageChange}
                currentPage={localStorage.getItem('page')}
                handleInvoiceStart={handleInvoiceStart}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                CampaignListFilter={true}
            />

           <ModalPop
                title={localization.conf}
                show={isConfirmationModal} 
                handleModalHide={handleConfirmationModalHide}
                keyboard
                isGoback
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{'Are you sure to start the campaign?'}</h5>
                    <a
                        className="btn btn-primary mb-4"
                        style={{ marginRight: '4%' }}   
                        onClick={handleConfirmationModalHide}
                    >
                        No
                    </a>
                    <a
                        className="btn btn-primary mb-4"
                        onClick={() => handleStartCampaign(getCampaignId)}
                    >
                        Yes
                    </a>
                </div>
            </ModalPop>


            <ModalPop
                title={localization.conf}
                show={isApprovedModal}
                handleModalHide={handleApprovedModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{'Campaign Started from L2'}</h5>
                <a
                    className="btn btn-primary mb-4"
                    onClick={() => window.location.reload()}
                  >
                    Back to list
                  </a>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default L2PendingList;




